const MultiplePages = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path d="M5.83337 15H8.75004H11.6667" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M5.83337 11.6667H6.25004H6.66671" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M5.83337 8.33333H7.08337H8.33337" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M5.83337 1.66667L13.75 1.66667L17.5 5.41667V15.8333" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    <path
      d="M2.5 16.8333V5.66667C2.5 4.83824 3.17157 4.16667 4 4.16667H11.8348C11.9939 4.16667 12.1465 4.22989 12.2591 4.34241L14.8243 6.9076C14.9368 7.02012 15 7.17274 15 7.33187V16.8333C15 17.6618 14.3284 18.3333 13.5 18.3333H4C3.17157 18.3333 2.5 17.6618 2.5 16.8333Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M11.6666 4.16667V6.90001C11.6666 7.23138 11.9353 7.50001 12.2666 7.50001H15"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export default MultiplePages;
